import {Link} from 'react-router-dom/cjs/react-router-dom';
import {VIEWPORT_WIDTHS} from 'configs';

import {useViewport} from 'contexts/ViewportContext';
import {Button, Nav, NavItem} from 'reactstrap';
import styles from './styles.module.scss';

export default function PublicNavActions(props) {
  const {utmProps} = props;
  const {size} = useViewport();
  const isMobile = VIEWPORT_WIDTHS[size] < VIEWPORT_WIDTHS.lg;

  const defaultProps = {
    tag: Link,
    to: '/register/user',
  };
  const enableUtm = !!utmProps;

  return (
    <Nav
      navbar
      className={
        isMobile
          ? styles['navigation__buttons-mobile']
          : styles['navigation__buttons']
      }
    >
      <NavItem>
        <Button tag={Link} outline to="/login" className="rounded" block>
          Log In
        </Button>
      </NavItem>

      <NavItem>
        <Button
          color="primary"
          className="rounded"
          block
          {...(enableUtm ? utmProps : defaultProps)}
        >
          Get Started
        </Button>
      </NavItem>
    </Nav>
  );
}
